import { z } from 'zod';
import { isISODate } from '../date';

export const zDate = z.string().refine(isISODate, { message: 'Datum im Format JJJJ-MM-TT erwartet' });
export const zCents = z.number().int({ message: 'Betrag in ganzen Cent erwartet' });
export const zId = z.string().regex(/^[a-f0-9]{24}$/, { message: 'Ungültige Id' });
export const zMonthDay = z.string().regex(/^\d{2}-\d{2}$/);
export const zReason = z.string().trim().min(5, { message: 'Bitte begründe die Änderung (mind. 5 Zeichen).' }).max(500);
export const zAddress = z.object({ street: z.string().max(200).optional(), zip: z.string().max(20).optional(), city: z.string().max(100).optional(), country: z.string().length(2).optional() });
export const zPage = z.object({ cursor: z.string().optional(), limit: z.coerce.number().int().min(1).max(100).optional() });
export const zAsOf = z.object({ asOf: zDate.optional(), knownAt: z.string().datetime().optional() });
